import { CollectionNames } from '../utils/collectionNames';
import { createSDSCollectionAndItem, createSDSCollectionItem } from 'mini-sds-gateway';
import { ItemNames } from '../utils/itemNames';
import type { EmailSignatureItemResponse } from '../schema/EmailSignatureResponse';
import type { EmailSignaturePreference } from '../schema/EmailSignaturePreference';

interface CreateEmailSignatureOptions {
    createCollection?: boolean;
}

export const createEmailSignaturePreference = async (
    data: EmailSignaturePreference,
    options?: CreateEmailSignatureOptions
): Promise<EmailSignatureItemResponse> => {
    const sdsApiMethodName = options?.createCollection
        ? createSDSCollectionAndItem
        : createSDSCollectionItem;

    return sdsApiMethodName(
        CollectionNames.ExtensionUserCustomProperties,
        ItemNames.EmailSignatureSettingsItem,
        { data }
    );
};
